import { useCallback, useEffect, useState } from 'react';
import taskService from '../../../services/TaskService';
import { mapTaskToRow } from '../helper/helper';

export default function useFetchMyTask() {
  const [myTaskLoading, setMyTaskLoading] = useState(false);
  const [myTaskRows, setMyTaskRows] = useState([]);

  const refreshMyTasks = useCallback(async ({ showLoading = false } = {}) => {
    try {
      if (showLoading) setMyTaskLoading(true);
      const response = await taskService.getMyTask();
      const tasks = response?.data?.data || [];
      setMyTaskRows(tasks.map(mapTaskToRow));
    } catch (error) {
      // eslint-disable-next-line no-console, no-undef
      console.error('Error fetching assigned tasks:', error);
    } finally {
      if (showLoading) setMyTaskLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMyTasks({ showLoading: true });
  }, [refreshMyTasks]);

  return { myTaskRows, setMyTaskRows, myTaskLoading, refreshMyTasks };
}
